import { DeclaredBusinessType } from '@nemuru-eng/js-api-client';

import { Text } from '../components/shared/components/Text';

export const DeclaredBusinessTypeOptions = Object.values(DeclaredBusinessType).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
